import CloseIcon from "../../../../assets/closeIcon.svg";
import playAudio from "../../../../assets/volume-max.svg";
import { IconButton } from "@mui/material";
import { Handle } from "@xyflow/react";
import RightArrow from "../../../../assets/arrow-right.svg";
import UsersIcon from "../../../../assets/users.svg";
import UserIcon from "../../../../assets/user.svg";
import { NodeActions } from "../ivr";


function getHeader(action, key) {
	let header = "";
	let display = key ? `- ${key}` : "";
	if (action === "Connect to User") header = `Connect to user ${display}`;
	else if (action === "Connect to Team") header = `Connect to team ${display}`;
	else if (action === "Play Audio") header = `${key} - Play Audio`;
	else if (action === "Hang Up") header = `${key} - Hang Up`;
	else header = key;
	return header;
}

export default function KeypressActionNode({data, selected}) {
	const header = getHeader(data.action, data.digit)
	
		  let dt;
		  if (data.selectedName && [NodeActions.toUser, NodeActions.toTeam].includes(data.action)) {
			dt = <>
			  Connect to
			  <img src={RightArrow} alt="Right Arrow" style={{ margin: "0 4px", width: "12px", height: "12px" }} />
			  {data.selectedName}
			</>;
		  } 
		  else if (data.action === NodeActions.playAudio) {
			  dt = <>
				Play Audio
			  	<img src={RightArrow} alt="Right Arrow" style={{ margin: "0 4px", width: "12px", height: "12px" }} />
				{(data.audio??{}).file? data.audio.file.name : ""}
			</>
		  }
		  else if (data.action) {
			dt = <>
			  {data.action}
			  <img src={RightArrow} alt="Right Arrow" style={{ margin: "0 4px", width: "12px", height: "12px" }} />
			</>;
		  }
		  else {
			dt = <>
			  Select Action
			  <img src={RightArrow} alt="Right Arrow" style={{ margin: "0 4px", width: "12px", height: "12px" }} />
			</>;
		  }

		  function icon() {
			if (data.action === NodeActions.toUser) {
			  return (
				<div style={{ width: 28, height: 28, borderRadius: "50%", backgroundColor: "#F8E9FE", display: "flex", alignItems: "center", justifyContent: "center" }}>
				  <img src={UserIcon} alt="User" style={localStyles.img} />
				</div>
			  );
			}
			if (data.action === NodeActions.toTeam) {
			  return (
				<div style={{ width: 28, height: 28, borderRadius: "50%", backgroundColor: "#F8E9FE", display: "flex", alignItems: "center", justifyContent: "center" }}>
				  <img src={UsersIcon} alt="Team" style={localStyles.img} />
				</div>
			  );
			}
			if(data.action === NodeActions.playAudio) {
				return (
					<div style={{ width: 28, height: 28, borderRadius: "50%", backgroundColor: "#F8E9FE", display: "flex", alignItems: "center", justifyContent: "center" }}>
						<img src={playAudio} alt="Play Audio" style={localStyles.img} />
				  	</div>
				)
			}
			return null;
		  }
		  return (
			<div style={{ position: "relative" }}>
			  <div style={{
				display: "inline-block",
				borderRadius: 8,
				padding: selected ? 4 : 0,
				boxShadow: (data.showInvalid && data.invalid) ? "0 0 0 0 #fff" : selected ? "0px 0px 3.01px 3.01px #34CB65, 0px 0px 0px 1.5px #FFFFFF" : "0 0 0 0 #fff",
      			border: (data.showInvalid && data.invalid) ? "1.5px solid #F44336" : "none",
				transition: "box-shadow 0.3s, padding 0.3s, border 0.3s",
				backgroundColor: "transparent"
			  }}>
				<div style={{ ...localStyles.container, padding: 0 }}>
				  <div style={{ backgroundColor: "#DC81F1", height: "6px", borderTopLeftRadius: "8px", borderTopRightRadius: "8px" }} />
				  <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "12px 16px" }}>
					<div style={{ display: "flex", alignItems: "center", gap: 8 }}>
					  {icon()}
					  <div className="t7 nc-gray-900 medium-font">{header}</div>
					</div>
					<IconButton disabled={!selected} onClick={data.onDelete} style={{ padding: 4, marginRight: -4 }}>
					  <img src={CloseIcon} alt="Close" style={{ width: "16px", height: "16px" }} />
					</IconButton>
				  </div>
				  <div style={{ height: "1px", backgroundColor: "#E0E0E0" }} />
				  <div style={{ padding: "16px" }} className="t8 nc-gray-900 medium-font">{dt}</div>
				</div>
				<Handle type="target" position="top" style={localStyles.handle} />
				{data.action === NodeActions.playAudio && <Handle type="source" position="bottom" style={localStyles.handle} />}
			  </div>
			</div>
		  );
}

// use target=source for Handle and use LooseConnection
const nodeDimensions = { width: "352px" };
const localStyles = {
	img: {
		width: 16,
		height: 16,
	},
	container: {
		width: nodeDimensions.width,
		border: "1px solid #E0E0E0",
		borderRadius: 8,
		backgroundColor: "#fff"
	},
	handle: {
		background: "#555" },
}